import { typeStyleFor } from "./buildingStyle";
import { LAYERS, BUILDING_PANEL } from "./theme";
const PANEL_WIDTH = 230;
let dom = null;
let escapeListener = null;
function getDom() {
    if (dom)
        return dom;
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.buildingInfoOverlay};
    width: ${PANEL_WIDTH}px;
    display: none;
    font-family: ui-sans-serif, system-ui, sans-serif;
    background: ${BUILDING_PANEL.background};
    border: 1px solid ${BUILDING_PANEL.border};
    border-radius: 8px;
    box-shadow: 0 10px 34px rgba(0,0,0,0.8), inset 0 1px 0 rgba(255,255,255,0.04);
  `;
    const header = document.createElement("div");
    header.style.cssText = `
    border-bottom: 1px solid ${BUILDING_PANEL.divider};
    padding: 8px 12px 7px;
    display: flex;
    align-items: center;
    gap: 6px;
  `;
    const typeDot = document.createElement("span");
    typeDot.style.cssText = `
    display: inline-block;
    width: 7px; height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  `;
    const typeLabel = document.createElement("span");
    typeLabel.style.cssText = `
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    flex: 1;
  `;
    const closeBtn = document.createElement("button");
    closeBtn.textContent = "×";
    closeBtn.style.cssText = `
    background: none;
    border: none;
    color: ${BUILDING_PANEL.description};
    font-size: 18px;
    line-height: 1;
    padding: 0 2px;
  `;
    closeBtn.addEventListener("click", () => hideBuildingInfoOverlay());
    header.append(typeDot, typeLabel, closeBtn);
    const body = document.createElement("div");
    body.style.cssText = "padding: 10px 12px 12px;";
    const title = document.createElement("div");
    title.style.cssText = `
    color: ${BUILDING_PANEL.title};
    font-size: 14px;
    font-weight: 600;
    line-height: 1.25;
    margin-bottom: 5px;
  `;
    const description = document.createElement("div");
    description.style.cssText = `
    color: ${BUILDING_PANEL.description};
    font-size: 12px;
    line-height: 1.4;
    margin-bottom: 6px;
  `;
    const owner = document.createElement("div");
    owner.style.cssText = `
    color: ${BUILDING_PANEL.owner};
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
  `;
    owner.innerHTML = `
    <svg width="10" height="10" viewBox="0 0 12 12" fill="none" style="flex-shrink:0">
      <circle cx="6" cy="4" r="2.5" stroke="${BUILDING_PANEL.owner}" stroke-width="1.2"/>
      <path d="M2 11c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="${BUILDING_PANEL.owner}" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
  `;
    const ownerName = document.createElement("span");
    owner.appendChild(ownerName);
    const actions = document.createElement("div");
    actions.style.cssText = "display: flex; gap: 8px; margin-top: 8px;";
    const visitBtn = document.createElement("button");
    visitBtn.textContent = "Besuchen →";
    visitBtn.style.cssText = `
    flex: 1;
    padding: 8px 10px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    border-radius: 5px;
    border: 1px solid rgba(200,168,130,0.4);
    background: rgba(200,168,130,0.12);
    color: ${BUILDING_PANEL.accent};
    display: none;
  `;
    const destroyBtn = document.createElement("button");
    destroyBtn.textContent = "Abreißen";
    destroyBtn.style.cssText = `
    flex: 1;
    padding: 8px 10px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    border-radius: 5px;
    border: 1px solid rgba(200,120,120,0.4);
    background: rgba(200,120,120,0.12);
    color: ${BUILDING_PANEL.danger};
    display: none;
  `;
    actions.append(visitBtn, destroyBtn);
    body.append(title, description, owner, actions);
    panel.append(header, body);
    document.body.appendChild(panel);
    dom = {
        panel,
        typeDot,
        typeLabel,
        title,
        description,
        owner,
        ownerName,
        visitBtn,
        destroyBtn,
    };
    return dom;
}
export function showBuildingInfoOverlay(x, y, company, actions) {
    const d = getDom();
    const style = typeStyleFor(company.kind, company.companyType, company.specialType);
    d.typeDot.style.background = style.color;
    d.typeLabel.style.color = style.color;
    d.typeLabel.textContent = style.label;
    d.title.textContent = company.title;
    d.description.textContent = company.description;
    d.description.style.display = company.description ? "" : "none";
    d.ownerName.textContent = company.ownerName ?? "";
    d.owner.style.display = company.ownerName ? "" : "none";
    d.visitBtn.style.display = actions.onVisit ? "" : "none";
    d.visitBtn.onclick = actions.onVisit ?? null;
    d.destroyBtn.style.display = actions.onDestroy ? "" : "none";
    d.destroyBtn.onclick = actions.onDestroy ?? null;
    d.panel.style.display = "block";
    // Position: centered above the tap point, clamped to viewport (same convention as the
    // desktop tooltip, but centered rather than offset since there's no cursor to trail).
    const margin = 10;
    const height = d.panel.offsetHeight;
    const left = Math.min(Math.max(x - PANEL_WIDTH / 2, margin), window.innerWidth - PANEL_WIDTH - margin);
    const top = Math.min(Math.max(y - height - 24, margin), window.innerHeight - height - margin);
    d.panel.style.left = `${left}px`;
    d.panel.style.top = `${top}px`;
    if (escapeListener)
        document.removeEventListener("keydown", escapeListener);
    escapeListener = (e) => {
        if (e.key === "Escape")
            hideBuildingInfoOverlay();
    };
    document.addEventListener("keydown", escapeListener);
}
export function hideBuildingInfoOverlay() {
    if (dom)
        dom.panel.style.display = "none";
    if (escapeListener) {
        document.removeEventListener("keydown", escapeListener);
        escapeListener = null;
    }
}
